import { render, staticRenderFns } from "./ProgramRoutineDetail.vue?vue&type=template&id=362ff38e"
import script from "./ProgramRoutineDetail.vue?vue&type=script&lang=js"
export * from "./ProgramRoutineDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports